const Template = `<div>
<left-menu :tubes="tubes" :phones="phones" @updateTubeList=getTubes></left-menu>
<form-window :phones="phones" :selected_phones="selected_phones" @updateTubeList=getTubes></form-window>
</div>`
export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page4_addmodem/template.js